import * as types from './mutation-types'

export default {
  [types.SET_CONFIG] (state, payload) {
    if (payload) {
      state.config = { ...state.config, ...payload }
    }
  }
}
